var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"videoWrapper"},[_c('iframe',{staticClass:"soli-round",attrs:{"src":_vm.src,"width":640,"height":360,"frameborder":"0","allowfullscreen":""}})])])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }